import { useNavigate } from "react-router-dom";
import { IconButton } from "@datapay-by-datacom/design-system";
import { IoKeyOutline } from "react-icons/io5";
import { useExpiringMcpKeys } from "../hooks/useExpiringMcpKeys";
import s from "./McpKeyExpiryAlert.module.css";

export function McpKeyExpiryAlert() {
  const { expiringKeys } = useExpiringMcpKeys();
  const navigate = useNavigate();
  const count = expiringKeys.length;

  if (count === 0) {
    return null;
  }

  return (
    <div className={s.alertContainer}>
      <IconButton
        className={s.alertButton}
        onPress={() => navigate("/settings")}
        aria-label={`${count} MCP key${count !== 1 ? "s" : ""} expiring soon`}
      >
        <IoKeyOutline size={20} />
        <span className={s.badge}>{count > 9 ? "9+" : count}</span>
      </IconButton>
    </div>
  );
}
